export default __webpack_public_path__ + "static/media/gallery_02.5616f3bb.jpg";